module.exports = __webpack_public_path__ + "assets/img/lajiTung.204980c9.svg";